import React, { useEffect, lazy } from 'react';
import AssignedTable from 'components/tables/assigned';
//const AssignedTable = lazy(() => import('components/tables/assigned'));
import {
    useGetListXMLExampleQuery,
    useGetListSimpleUIListQuery,
} from 'reduxStore/services/uiList.services';
import { processXMLData } from 'utils/processXMLData';
import { getDataHeaders } from 'utils/getDataHeaders';
import { getDataSorts } from 'utils/getDataSorts';
import { getDataWidth } from 'utils/getDataWidth';
import { useAppDispatch } from 'reduxStore/hooks';
import { Spin } from 'antd';

import {
    setXMLData,
    setDataHeaders,
    setDataWidths,
    setDataSorts,
    setListTitle,
    setTotalAssets,
} from 'reduxStore/slices/asignToPerson.slice';
import config from 'config';

export default function Home() {
    const urlParams = window.location.search;

    const ALLOCATED_TO_PERSON_ID = 11;
    const { projectID, dtsRecordID, Query, Sort, Layout, ContainerID, ListTitle } =
        Object.fromEntries(new URLSearchParams(urlParams));
    const dispatch = useAppDispatch();

    const { data: getXMLDataDEV } = useGetListXMLExampleQuery(
        {},
        { skip: config.ENVIROMENT !== 'DEVELOPMENT' },
    );

    const dataParams = {
        QueryID: Query,
        LayoutID: Layout,
        SortID: Sort,
        Params: [
            {
                Val: dtsRecordID,
                Field: ALLOCATED_TO_PERSON_ID,
            },
        ],
    };
    const { data: getXMLData } = useGetListSimpleUIListQuery(dataParams, {
        skip: config.ENVIROMENT !== 'PRODUCTION',
    });

    const data = config.ENVIROMENT === 'DEVELOPMENT' ? getXMLDataDEV : getXMLData;
    if (data) {
        const convertToXML = async () => {
            try {
                const dataHeaders = await getDataHeaders(data);
                const preocessData = await processXMLData(data);
                const dataWidths = await getDataWidth(data);
                const dataSorts = await getDataSorts(data);

                dispatch(setDataHeaders(dataHeaders));
                dispatch(setXMLData(preocessData));
                dispatch(setDataWidths(dataWidths));
                dispatch(setDataSorts(dataSorts));
                preocessData && dispatch(setTotalAssets(preocessData.length));
                ListTitle && dispatch(setListTitle(ListTitle));
            } catch (e) {
                console.log(e);
            }
        };
        convertToXML();
    }

    return (
        <main className="VZ__table__wrapper">
            <section className="VZ__table">
                <section className="VZ__table__content">
                    <section className="section section--no-padding ">
                        <AssignedTable />
                    </section>
                </section>
            </section>
        </main>
    );
}
